/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { makeStyles, useTheme } from '@material-ui/core/styles'
import React from 'react'

import { remSizeFor, Theme } from '../../lib/theming'
import Image from '../shared/Image'
import { breakpointHeaderHeightsRem } from './Header'
import SlideOutLogo from './SlideOutLogo'

const MAX_WIDTH = 256

const useStyles = makeStyles<Theme>(({ palette }) => ({
  logoLink: {
    '& img': {
      height: 'auto',
      lineHeight: 1,
      maxHeight: '100%',
      maxWidth: '100%',
      width: 'auto',
    },
    '&:hover, &:focus': {
      backgroundColor: 'transparent',
    },
    alignItems: 'center',
    color: palette.common.white,
    display: 'flex',
    height: '100%',
    justifyContent: 'flex-start',
    marginRight: 'auto',
    maxWidth: MAX_WIDTH,
    overflow: 'hidden',
    textDecoration: 'none',
  },
  logoText: {
    lineHeight: '1.2',
    marginBottom: 0,
    marginLeft: '.5rem',
    marginTop: 0,
    textAlign: 'left',
    whiteSpace: 'pre-line',
  },
}))

const HeaderLogo = ({
  logo,
  slideOutAnimation = false,
  slideOutAmount = 0,
}: {
  logo?: { altText?: string | null; id?: string | null; url?: string | null } | null
  slideOutAmount?: number | null
  slideOutAnimation?: boolean | null
}) => {
  const classes = useStyles()
  const theme = useTheme<Theme>()
  const maxHeight = remSizeFor(breakpointHeaderHeightsRem, theme) - theme.spacing(2)

  const logoComponent = logo?.url && (
    <Image
      height={maxHeight}
      htmlAttributes={{ alt: logo.altText || 'Conference logo' }}
      imgixParams={{ fit: 'fillmax' }}
      src={logo.url}
      width={MAX_WIDTH}
    />
  )

  return (
    <a className={classes.logoLink} href="/">
      {slideOutAnimation && slideOutAmount && logoComponent ? (
        <SlideOutLogo slideOutAmount={slideOutAmount}>{logoComponent}</SlideOutLogo>
      ) : (
        logoComponent
      )}
    </a>
  )
}
export default HeaderLogo
